import type * as React from "react";

/** Centered placeholder for empty panels and first-run views. Optional round icon chip, title, supporting copy, and an action slot. */
export interface EmptyStateProps {
  /** Round icon chip (icon element / ReactNode). */
  icon?: React.ReactNode;
  title?: React.ReactNode;
  children?: React.ReactNode;
  /** Action slot (e.g. a Button). */
  action?: React.ReactNode;
  style?: React.CSSProperties;
}

export function EmptyState({ icon, title, children, action, style }: EmptyStateProps) {
  return (
    <div
      style={
        {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          gap: 10,
          padding: "40px 28px",
          color: "var(--text-muted)",
          fontFamily: "var(--font-sans)",
          ...style,
        } as React.CSSProperties
      }
    >
      {icon && (
        <div
          style={{
            display: "grid",
            placeItems: "center",
            width: 52,
            height: 52,
            borderRadius: "var(--radius-pill)",
            background: "var(--surface-sunken)",
            color: "var(--text-secondary)",
            marginBottom: 2,
          }}
        >
          {icon}
        </div>
      )}
      {title && (
        <div style={{ fontSize: "var(--text-body-lg)", fontWeight: "var(--fw-bold)", color: "var(--text-strong)" }}>{title}</div>
      )}
      {children && <div style={{ fontSize: "var(--text-body-sm)", lineHeight: 1.5, maxWidth: 260 }}>{children}</div>}
      {action && <div style={{ marginTop: 8 }}>{action}</div>}
    </div>
  );
}
